module.exports = __webpack_public_path__ + "img/jobs_style_guides_tab.f3d85504.svg";